import { Component } from 'react';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/_notifications.scss';








export default class NotificationsProvider extends Component


{
  constructor(props) {
    super(props);

    toast.configure({
      position: 'bottom-left'
    });
  }

  render() {
    const { children } = this.props;

    return children;
  }
}